import { gql } from "@apollo/client";

export const GET_PORCENTAJE_MAX_MONTO_AJUSTE = gql`
    query porcentajeMaxMontoAjuste {
        porcentajeMaxMontoAjuste {
            valorEsperado
            success
        }
    }
`;